import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import getClassNameFromType from './button_card/helpers/get_class_name_from_type';

const ButtonCard = React.forwardRef((props, ref) => {
  const className = classnames(props.className, {
    active: props.active,
    multiline: props.multiline,
    'bvs-button-card': !props.noClass,
  }, getClassNameFromType(props.type));

  return (
    <button className={className} onClick={props.onClick} ref={ref} type="button">
      {props.label}
      {props.children}
    </button>
  );
});

ButtonCard.propTypes = {
  onClick: PropTypes.func,
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
  active: PropTypes.bool,
  children: PropTypes.node,
  multiline: PropTypes.bool,
  noClass: PropTypes.bool,
  type: PropTypes.string,
};

ButtonCard.defaultProps = {
  onClick: () => {},
  className: '',
  active: false,
  children: null,
  multiline: false,
  noClass: false,
  type: null,
};

export default ButtonCard;
